import React from 'react';
import { Link } from 'react-router-dom';
import ReactLoading from 'react-loading';
import { connect } from 'react-redux';
// import { this.props.history } from 'react-router';
import { bindActionCreators } from 'redux';
import * as appointmentActions from '../../actions/appointmentActions';
import * as SVGICONS from '../../images/img/images';
import Pagination from "react-js-pagination";
// import Moment from 'react-moment';
import Noshow from '../sitemanagement/noshow';
import AppointmentDocs from '../sitemanagement/appointmentDocs';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import ReactTooltip from 'react-tooltip';
import moment from 'moment';
import * as constant from '../../constants/constant';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NoShowAppointment from '../sitemanagement/noshowappointment';
// import '../../styles/css/date-picker.css'
import './calendar.css'
import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import { constants } from 'zlib';
import $ from "jquery";
import * as dashboardActions from "../../actions/dashboardActions";
const momentTimezone = require('moment-timezone');
class MyAppointment extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			conditionModal: false,
			appointmentList: [],
			token: '',
			specialistId: '',
			flag: 1,
			activePage: 1,
			count: 10,
			sortColumnName: '',
			sortOrder: -1,
			isConfirm: false,
			activeTab1: "active",
			activeTab2: "",
			Appointment: false,
			displayNoAppointmentShow: false,
			logoutButton: false,
			noshowId: null,
			noshowItem: null
			// appointmentDocument: []
		};
		this.deleteAppointment = this.deleteAppointment.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.goToDetailsPage = this.goToDetailsPage.bind(this);
		this._sortClass = this._sortClass.bind(this);
		this.sortChanged = this.sortChanged.bind(this);
		this.onChange = this.onChange.bind(this)
		this.hideConditionModal = this.hideConditionModal.bind(this);
		// this.appointmentDocuments = this.appointmentDocuments.bind(this)
		this.hidedocModal = this.hidedocModal.bind(this);
		this.goToAppointmentHistory = this.goToAppointmentHistory.bind(this)
		this.hideNoShowAppointmentModal = this.hideNoShowAppointmentModal.bind(this)
		this.searchName = this.searchName.bind(this)
		this.searchAppointments = this.searchAppointments.bind(this);
		this.searchAptDate = this.searchAptDate.bind(this);
		this.onLogoutclick = this.onLogoutclick.bind(this);
		this.toggle = this.toggle.bind(this)
		this._logout = this._logout.bind(this)
		this.nextNohowReminder = this.nextNohowReminder.bind(this);

		this.handleClick = this.handleClick.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);
	
	}

	_logout(event) {
		let userId = localStorage.getItem('userId')
		this.props.logoutAction.logout({ 'userId': userId })
		event.preventDefault();
		localStorage.clear();
		this.props.history.push('/');
	}
	toggle(e, menuClicked) {
		var windowWidth = $(window).width();
		if (windowWidth <= 768) {
			if (e == true) {
				$("body").toggleClass("sidebar-open");
			} else {
				$("body").toggleClass("sidebar-open");
			}
		}

		// if(windowWidth < 768 ){

		// 	$("body").toggleClass("sidebar-open");
		// }
		if (windowWidth >= 768) {
			if (e == true) {
				$("body").toggleClass("sidebar-collapse");
			} else if (e == false) {
				$("body").toggleClass("sidebar-collapse");
			}
		}
	}
	goToAppointmentHistory(patientId) {
		this.props.history.push('/specialist/appointment-history/' + patientId);
	}
	componentWillMount() {
		// var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		//     assistID = user.assistId
		localStorage.removeItem('consultationOpenFrom');

		localStorage.removeItem('patienthistory')

		if (localStorage.getItem('consult'))
			localStorage.removeItem('consult');
		let userToken = localStorage.getItem('token');
		let specialistId = localStorage.getItem('userId');
		let appointmentObj = {
			token: userToken,
			specialistId: specialistId,
			flag: 1,
			count: this.state.count,
			page: 1
		};
		// this.setState({ activeTab1: "active", activeTab2: "" });
		this.props.actions.getAppointments(appointmentObj, this.props);
		this.changeAptType = this.changeAptType.bind(this);
		this.state.current = 1;
		this.props.actions.noShowAppointment(appointmentObj, this.props);
	}

	nextNohowReminder() {
		this.setState({ displayNoAppointmentShow: false })
		let userToken = localStorage.getItem('token');
		let specialistId = localStorage.getItem('userId');
		localStorage.removeItem('patienthistory')

		if (localStorage.getItem('consult'))
			localStorage.removeItem('consult');
		let appointmentObj = {
			token: userToken,
			specialistId: specialistId,
			flag: 1,
			count: this.state.count,
			page: 1
		};
		// this.setState({ activeTab1: "active", activeTab2: "" });
		// this.props.actions.getAppointments(appointmentObj);
		// this.changeAptType = this.changeAptType.bind(this);
		this.state.current = 1;
		this.props.actions.noShowAppointment(appointmentObj)
	}
	componentWillReceiveProps(nextProps) {
		this.setState({
			appointmentList: nextProps.appointmentList,
			totalCount: nextProps.totalCount,
			noShowAppointments: nextProps.noShowappointmentList,
			displayNoAppointmentShow: (nextProps.noShowappointmentList && nextProps.noShowappointmentList.length > 0 && JSON.parse(localStorage.getItem('noShowRemind')) == true) ? true : false
		})
		localStorage.setItem('totalCount', nextProps.totalCount);
		localStorage.setItem('noShowAppointments', true)
		if (localStorage.getItem('isClicked') === "true") {
			localStorage.removeItem('isClicked')

			this.changeAptType(1)
		}
	}

	onChange(itemId, item, event) {
		// let pastAppointment = new Date(new Date(item.checkappointmentDate).getTime() + diff*60000);
		let differenceInTime = new Date().getTime() - new Date(item.checkappointmentDate);
		debugger // eslint-disable-line

		// moment(item.checkappointmentDate).add(30, 'm').toDate();
		if (differenceInTime > 30*60000) {
			this.setState({
				conditionModal: true,
				noshowId: itemId,
				noshowItem: item
			});
		} else {
			debugger // eslint-disable-line
		}
	}

	searchName(event) {
		this.setState({ "searchname": event.target.value });
	}

	searchAptDate(dates) {
		let mu = dates;
		this.setState({ "searchdate": mu });
	}

	searchAppointments() {
		let specialistId = localStorage.getItem('userId');
		let appointmentObj = {
			specialistId: specialistId,
			flag: this.state.flag,
			count: this.state.count,
			page: this.state.activePage,
			name: this.state.searchname,
			sortOrder: this.state.sortOrder,
			sorting: this.state.sorting,
			searchdate: this.state.searchdate
		};
		this.props.actions.getAppointments(appointmentObj);
	}

	handlePageChange(pageNumber) {
		
		this.setState({ activePage: pageNumber });
		let userToken = localStorage.getItem('token');
		let specialistId = localStorage.getItem('userId');
		let user = JSON.parse(localStorage.getItem('user'));
		let assistId = user.assistId;
		if (assistId && assistId != '') {
			let appointmentObj = {
				token: userToken,
				specialistId: assistId,
				flag: this.state.flag,
				count: this.state.count,
				page: pageNumber,
				sorting: this.state.sorting,
				sortOrder: this.state.sortOrder
			};
			this.props.actions.getAppointments(appointmentObj);

		} else {
			let appointmentObj = {
				token: userToken,
				specialistId: specialistId,
				flag: this.state.flag,
				count: this.state.count,
				page: pageNumber,
				sorting: this.state.sorting,
				sortOrder: this.state.sortOrder
			};
			this.props.actions.getAppointments(appointmentObj);

		}

	}

	componentDidMount() {
		if (this.state.flag == 1) {
			let userToken = localStorage.getItem('token');
			let specialistId = localStorage.getItem('userId');
			let appointmentObj = {
				token: userToken,
				specialistId: specialistId,
				flag: this.state.flag,
				page: 1,
				count: this.state.count,
				sortOrder: this.state.sortOrder
			};
		}
	}



	changeAptType(data) {
		if (data == 2) {
			this.state.activeTab2 = "active";
			this.state.activeTab1 = "";

		} else {
			this.state.activeTab1 = "active";
			this.state.activeTab2 = "";
		}
		let userToken = localStorage.getItem('token');
		let specialistId = localStorage.getItem('userId');
		let appointmentObj = {
			token: userToken,
			specialistId: specialistId,
			flag: data,
			page: 1,
			count: this.state.count,
			sortOrder: this.state.sortOrder
		};
		this.setState({
			flag: data
		})
		this.props.actions.getAppointments(appointmentObj);
	}

	goToDetailsPage(availabilityId, status, patientId, time, date) {
		
		localStorage.setItem('patientId', patientId)
		if (status)
			localStorage.setItem('consult', "consult")
		else 
			localStorage.setItem('consult', "unconsult")
		// window.location.href = constant.PRODUCTION_CURRENT_URL + 'specialist/appointment-consultation/' + availabilityId;
		this.props.history.push('/specialist/appointment-consultation/' + availabilityId);
	};


	// function for set sort icon on table header
	_sortClass(filterName) {
		return "fa fa-fw " + ((filterName == this.state.sortColumnName) ? ("fa-sort-" + this.state.sortOrder) : "fa-sort");
	}

	//function for sorting
	sortChanged(sortColumnName, order, e) {

		e.preventDefault();

		this.state.sortColumnName = sortColumnName;
		this.state.page = 1;
		this.state.sortOrder = order == 1 ? -1 : 1;

		let userToken = localStorage.getItem('token');
		let specialistId = localStorage.getItem('userId');
		const sorting = {}
		sorting[sortColumnName] = order.toString().toLowerCase() == 1 ? -1 : 1
		this.state.sorting = sorting;
		let appointmentObj = {
			token: userToken,
			specialistId: specialistId,
			flag: this.state.flag,
			page: this.state.activePage,
			count: this.state.count,
			sorting: sorting
		};
		this.props.actions.getAppointments(appointmentObj);
	}

	hideConditionModal() {
		//  ;
		this.setState({ conditionModal: false, isConfirm: true });
		this.changeAptType(1);
	}

	deleteAppointment(data) {
		var firstName = data.patientInfo[0].userName.split(" ")[0][0].toUpperCase() + data.patientInfo[0].userName.split(" ")[0].substring(1)
		var lastName = data.patientInfo[0].lastName ? data.patientInfo[0].userName.split(" ")[1][0].toUpperCase() + data.patientInfo[0].userName.split(" ")[1].substring(1) : ''
		var patientName = firstName + ' ' + lastName;
		let nowDiffFromAppointment = /* Math.abs( */(new Date(data.checkappointmentDate) - new Date())/36e5;
		
		if (nowDiffFromAppointment > 2) {
			confirmAlert({
				title: 'Confirm',
				message: 'Do you wish to cancel the appointment with ' + patientName + '?',
				buttons: [
					{
						label: 'Yes',
						onClick: () => {
							let appointmentObj = {
								// token: userToken,
								patientId: data.patientId,
								appointmentId: data._id,
								flag: this.state.flag,
								count: this.state.count,
								page: this.state.activePage,
								userType: 'Specialist'
							};
							
							this.props.actions.deleteAppointment(appointmentObj);
						}
					},
					{
						label: 'No',
						onClick: () => { this.props.history.push('/specialist/my-appointment'); }
					}
				]
			})
		}else {
			confirmAlert({
				customUI: ({ onClose }) => {
					return (
						<div className='custom-ui disclaimer_appointement'>
						<a  style={{ cursor: "pointer" }} className="closeBtn" onClick={onClose}></a>
	
							<h1>Error</h1>
							{/* <p> {nextProps.convertedCurrency.query.amount} {nextProps.convertedCurrency.query.from} = {currancy} {localStorage.getItem('currency')}</p> */}
							<span> You can cancel an appointment only 2 hours prior to appointment time</span>
							<div className="bottomBtn text-center"><button type="button"  onClick={onClose}	 className="btn btn-warning btn-lg">Ok</button></div>
						</div>
					)
				}
			})
		}
	}

	appointmentDocuments(data) {
		this.setState({ docModal: true, appointmentId: data._id, patientId: data.patientInfo[0]._id })
		let appointmentObj = {
			appointmentId: data._id,
		};
	}

	hidedocModal() {
		this.setState({ docModal: false })
	}

	hideNoShowAppointmentModal() {

		this.setState({ displayNoAppointmentShow: false })
	}


	// GetFormattedDate(days) {
	// 	var today = new Date(moment(days));
	// 	var day = today.getDate();
	// 	var month = today.getMonth() + 1;
	// 	var year = today.getFullYear();
	// 	return day + "-" + month + "-" + year;
	// }

	onLogoutclick(data) {
		if (this.state.logoutButton == false) {
			this.setState({
				logoutButton: true
			});
		}
		else {
			this.setState({
				logoutButton: false
			});
		}
	}

	handleOutsideClick(e) {
		// ignore clicks on the component itself
		if (this.node && this.node.contains(e.target)) {
			return;
		}

		this.handleClick();
	}
	handleClick() {
		if (!this.state.logoutButton) {
			// attach/remove event handler
			document.addEventListener('click', this.handleOutsideClick, false);
		} else {
			document.removeEventListener('click', this.handleOutsideClick, false);
		}

		this.setState(prevState => ({
			logoutButton: !prevState.logoutButton,
		}));
	}
	render() {
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var isAssistant = user ? user.assistId ? true : false : false;
		var appointmentsList = this.state.appointmentList;
		var rows = [];
		let userlocation = moment(new Date()).tz(moment.tz.guess()).format('z');

		var defaultImagePath = user.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png';
		if (user.image == constant.DEFAULT_USER_IMAGE) {
			var imagePath = user.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png';
		} else {
			var imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image;
		}
		{
			(this.state.appointmentList && this.state.appointmentList.length > 0) ? this.state.appointmentList.forEach(function (item, index) {
				if (item.patientInfo) {

					var defaultpatientImage = item.patientInfo[0].gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_f.png';

					rows.push(<tr key={index}>
						<td><div className="appUser">
							<img className="appointment-list-img" src={defaultpatientImage/* constant.PRODUCTION_IMAGE_URL + 'uploads/' + item.patientInfo[0]._id + '/' + item.patientDet[0].profileImage */} onError={(e) => { e.target.src = defaultpatientImage }} />
							{this.state.activeTab2 && this.state.activeTab2 == "active" ?
								''
								:
								<i className="greenDot" style={{ 'display': (item.appointmentMode == 2 && item.patientInfo[0].token != '' && item.patientInfo[0].isLoggedIn ? 'block' : 'none') }}></i>
							}</div>

						</td>
						<td>{(this.state.activeTab2 && this.state.activeTab2 == "active") ? <p className="text-capitalize">{item.patientInfo[0].firstName} {item.patientInfo[0].lastName}</p> : <Link className="text-capitalize" href="#" onClick={this.goToDetailsPage.bind(this, item._id, false, item.patientInfo[0]._id)}>
							{item.patientInfo[0].firstName} {item.patientInfo[0].lastName}
						</Link>}
						</td>
						<td>
							{/* {item ? moment(moment.utc(item.appointmentDate).toDate()).format('DD-MMM-YYYY') : ''} */}
							{/* item ? moment(moment.utc(item.appointmentDate).toDate()).format('DD-MMM-YYYY') : ''*/}
							{item ? moment.parseZone(new Date(item.checkappointmentDate)).format('DD-MM-YYYY') : ''}
							{/* <Moment format="DD-MMM-YYYY">{item.appointmentDate}</Moment> */}
							{/* {JSON.stringify(new Date(item.appointmentDate))} */}
							{/* {this.GetFormattedDate(item.appointmentDate)} */}
						</td>
						<td>
							{/* {item.appointmentTime} */}
							{/* {item ? moment(moment.utc(item.appointmentDate, "h:mm:ss A").toDate()).format("HH:mm") : ''} */}
							{item ? moment.parseZone(new Date(item.checkappointmentDate)).format('hh:mm A') + " " + userlocation: ''}
						</td>
						<td>

							{item ? item.clinicName : ''}
						</td>
						<td>
							{item && item.patientDet[0] && moment().diff(item.patientDet[0].dateOfBirth, 'years') == 0 ? moment().diff(item.patientDet[0].dateOfBirth, 'months') + ' M' : moment().diff(item.patientDet[0].dateOfBirth, 'years') + ' Y'}
						</td>
						<td>
							{item && item.patientInfo[0].gender}
						</td>
						{!isAssistant ? <td>
							<a data-tip data-for={'global' + index} className="Blogtext appointment-listing">
								{item.symptoms}
							</a>
							<ReactTooltip id={'global' + index} aria-haspopup='true' type='warning' effect='solid' place='bottom' className="customeTheme appointment-listing-tooptip" >
								<p>{item.symptoms}</p>
							</ReactTooltip>
						</td>
							: null
						}
						<td>
							{item.appointmentMode == 1 ? 'F2F' : 'Online'}
						</td>
						{(item.appointmentStatus == 1 && item.isDeleted == false && this.state.flag == 1) ?

							<td className="cbp-vm-icon cbp-vm-Status statusGreen">Confirmed</td> :
							(item.appointmentStatus == 1 && item.isDeleted == false && this.state.flag == 2) ? <td> <button type="button" className="btn btn-block btn-warning consultBtnTd" disabled={isAssistant} onClick={this.goToDetailsPage.bind(this, item._id, true, item.patientInfo[0]._id, item.appointmentTime, item.appointmentDate)}>Consult{moment(item.appointmentDateUTC).isSame(new Date())}</button> </td> : item.appointmentStatus == 2 ? <td className="cbp-vm-icon cbp-vm-Status statusGreen">Completed</td> : item.appointmentStatus == 3 ? <td className="cbp-vm-icon cbp-vm-Status statusRed">No show-Specialist </td> : item.appointmentStatus == 4 ? <td className="cbp-vm-icon cbp-vm-Status statusRed">No show-Patient</td> : item.appointmentStatus == 5 ? <td>Reserved</td> : (item.appointmentStatus == 6 || item.isDeleted == true || (item.appointmentStatus == 1 && item.isDeleted == true)) ? <td className="cbp-vm-icon cbp-vm-Status statusOrange">Cancelled By {item.isDeletedBy}</td> : <td></td>}
						{!isAssistant ? <td >
							<div ><Link href="#" className="tooltip-custom fadeEffect tisymtomhover" data-title="Documents" onClick={this.appointmentDocuments.bind(this, item)}><img src={require('../../images/img/book.png')} style={{ 'cursor': 'pointer' }} /></Link></div>
							{this.state.docModal ? <AppointmentDocs openModal={this.state.docModal} hideConditionModal={this.hidedocModal} appointmentId={this.state.appointmentId} patientId={this.state.patientId} /> : ''}
						</td>
							: null
						}
						{!isAssistant ? <td><Link className="tooltip-custom fadeEffect tisymtomhover cancelRightTooltip" data-title="Appointments History" onClick={this.goToAppointmentHistory.bind(this, item.patientInfo[0]._id)} ><img src={require('../../images/img/availability_icon.png')} style={{ 'cursor': 'pointer' }} /></Link></td>
							: null
						}
						{this.state.flag == 1 ? <td>
							{this.state.conditionModal ? <Noshow hideConditionModal={this.hideConditionModal} appointmentId={this.state.noshowId} openModal={this.state.conditionModal} appointmentDet={this.state.noshowItem} /> : ''}
							{(this.state.flag == 1 && item.appointmentStatus == '1') ? <div><Link href="#" className="noshowImg tooltip-custom fadeEffect tisymtomhover" data-title="No Show" onClick={this.onChange.bind(this, item._id, item)}><img src={require('../../images/img/noshow.png')} className="" /></Link></div> : ''}
						</td> : ''}
						{this.state.flag == 1 ? <td>{(this.state.flag == 1 && item.appointmentStatus == '1') ? <button type="button" disabled={isAssistant || moment.parseZone(new Date(item.checkappointmentDate)).isAfter(momentTimezone.tz(moment.tz.guess()).endOf('day')) || moment.parseZone(new Date(item.checkappointmentDate)).isBefore(momentTimezone.tz(moment.tz.guess()).startOf('day'))} className="btn btn-block btn-warning consultBtnTd" onClick={this.goToDetailsPage.bind(this, item._id, true, item.patientInfo[0]._id, item.appointmentTime, item.appointmentDate)}>Consult</button> : ''}
						</td> : ''}

						{this.state.flag == 1 ? <td>{(this.state.flag == 1 && item.appointmentStatus == '1') ? <div className="cbp-vm-icon cbp-vm-close"><Link href="#" onClick={this.deleteAppointment.bind(this, item)} className="tooltip-custom fadeEffect tisymtomhover cancelRightTooltip" data-title="Cancel appointment"><SVGICONS.CancelSvg /></Link></div> : ''}</td> : ''}
						{(this.state.flag == 1 && item.appointmentStatus == '4') ?
							<td >No Show - Patient</td>
							: ''
						}
						{(this.state.flag == 1 && item.appointmentStatus == '3') ?
							<td >No Show - Specialist</td>
							: ''
						}
					</tr>)
				}
			}.bind(this)) : " "
		};

		var sidebartoggle = true;
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var condition = (((user.userName != undefined || user.gender != undefined) && user.availabilityCount > 0) && user.isVerified == '2');
		var userType = localStorage.getItem('userType');
		
		return (
			<div>
				<header className="main-header">
				<Link to={condition ? "/specialist/my-appointment" : null} className="logo">						<span className="logo-mini">{userType === 'specialist' ? <img src={require('../../images/img/logo_er_ms_specialist.png')} alt="" /> : <img src={require('../../images/img/logo_er_ms.png')} alt="" />}</span>
						<span className="logo-lg">{userType === 'specialist' ? <img src={require('../../images/img/logo_er.png')} alt="" /> : <img src={require('../../images/img/logo_er_old.png')} alt="" />}</span> </Link>
					<nav className="navbar navbar-static-top" role="navigation">
						<Link to="#" className="sidebar-toggle sidebar-toggle-doctor" data-toggle="push-menu" role="button" onClick={this.toggle.bind(this, !sidebartoggle)}> <img src={require('../../images/img/menu_list.svg')} alt="" /> <span className="sr-only">Toggle navigation</span> </Link>



						<div className="topSearch">
							<div className="row">

								<div className="col-lg-5 col-md-4 col-sm-5 col-xs-5">
									<div className="">
										<div className="input-group inputBg email">
											<span className="input-group-addon">
												<i className="fa ">
													<img src={require('../../images/img/user_input_icon.svg')} alt="" />
												</i>
											</span>
											<input type="text" name="searchname" id="searchname" value={this.state.searchname ? this.state.searchname : ''} className="form-control p-d-20" placeholder="Name" onChange={this.searchName} />
										</div>
									</div>
								</div>
								<div className="col-lg-5 col-md-5 col-sm-4 col-xs-5 tab-respon-landscape-paddingleft">
									<div className="">
                                    <div className="date-picker form__form-group-input-wrap form__form-group-input-wrap--error-above">

										<div className="input-group date inputBg dateInputfild" style={{ color: '#4d4d4d !important' }}>
											<div className="input-group-addon">
											<i className="fa ">
												<img src={require('../../images/img/date_input_icon.svg')} /></i>
												</div>
											<DatePicker
												name="searchdate"
												dateFormat="dd-MM-yyyy"
												selected={this.state.searchdate}
												onChange={this.searchAptDate}
												placeholderText="Date"
												// maxDate={moment().add(1, 'year')}
												// minDate={moment().subtract(1, 'year')}
												showMonthDropdown
												showYearDropdown
												shouldCloseOnSelect={true}
											/>

										</div>
									</div>
									</div>
								</div>
								<div className="col-lg-2 col-md-3 col-sm-2 col-xs-2 tab-respon-landscape-padding">
									<div className=" searchBtn">
										<button type="button" className="btn btn-warning btn-lg" data-toggle="modal" onClick={this.searchAppointments.bind(this)}>Search</button>
									</div>
								</div>

							</div>
						</div>
						<div className="navbar-custom-menu">
							<ul className="nav navbar-nav">
								<li ref={node => { this.node = node; }} onClick={this.handleClick}  className={this.state.logoutButton == true ? "dropdown user user-menu show" : "dropdown user user-menu"}>
									<Link href="#" className="dropdown-toggle" data-toggle="dropdown">
										<img src={imagePath} className="user-image" alt="User Image" onError={(e) => { e.target.src = defaultImagePath }} />
										<span className="hidden-xs name-capitalize">{user.firstName ? user.firstName : ''} {user.lastName ? user.lastName : ''}</span> </Link>

									<ul className={this.state.logoutButton === true ? "dropdown-menu popupdropdown show" : "dropdown-menu popupdropdown"}>

										<li className="user-setting">	<Link to={{ pathname: "/specialist/my-settings", state: 1 }}>

											<img
												src={require('../../images/Slicing/Settings-profile.png')}
												className="user-image"
												alt="User Image"
												onError={e => {
													e.target.src = defaultImagePath;
												}}
											/>
											<span>Settings</span>
										</Link></li>
										<li
											className="user-footer passwordLink"
										// style={{ textAlign: "center" }}
										>

											<Link

												className="uploadLink"
												onClick={this._logout}
											>
												<img
													src={require('../../images/Slicing/logout-profile.png')}
													className="user-image"
													alt="User Image"
													onError={e => {
														e.target.src = defaultImagePath;
													}}
												/>
												<span>	Sign out</span>
											</Link>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</nav>
				</header>
				<div className="content-wrapper">
					{this.state.displayNoAppointmentShow ? < NoShowAppointment openNoAppointmentShowModal={this.state.displayNoAppointmentShow} noShowappointmentList={this.state.noShowAppointments} closeNoShowAppointmentModal={this.hideNoShowAppointmentModal} nextNohowReminder={this.nextNohowReminder} /> : ''}
					{this.state.isLoader ? <div className="loaderCenter"> <ReactLoading type={'bars'} color={'blue'} /></div> :
						<section className="content container-fluid verify_ipad-spacing">
							<ToastContainer />
							<div className="row">
								<div className="col-md-12">
									<div className="">
										<div className="nav-tabs-custom">
											<ul className="nav nav-tabs">
												<li><Link href="#tab_1" className={this.state.activeTab1 + " show"} data-toggle="tab" onClick={this.changeAptType.bind(this, 1)}>Upcoming Appointments</Link></li>
												<li><Link className={this.state.activeTab2 + " show"} href="#tab_2" data-toggle="tab" onClick={this.changeAptType.bind(this, 2)}>Past Appointments</Link></li>
											</ul>
											<div className="tab-content" style={{ "minHeight": 410 }}>
												<div className="tab-pane active" id="tab_1">
													<div id="cbp-vm" className="cbp-vm-switcher cbp-vm-view-grid">
														<div className="cbp-vm-options">

														</div>
														<div className="table-responsive verticaltophead">
															<table className="table table-striped table-bordered table-hover">
																<thead>
																	<tr>
																		<th>

																		</th>

																		<th
																			onClick={this.sortChanged.bind(this, 'patientInfo.firstName', this.state.sortOrder)}>
																			Patient Name{this.state.Appointment}
																			<i className={this._sortClass('appointmentspecialistname')}></i>
																		</th>
																		<th
																			onClick={this.sortChanged.bind(this, 'appointmentDate', this.state.sortOrder)}>
																			Appointment Date
                                <i className={this._sortClass('appointmentdate')}></i>
																		</th>
																		<th
																			onClick={this.sortChanged.bind(this, 'appointmentTime', this.state.sortOrder)}>
																			Appointment Time
                                <i className={this._sortClass('appointmentdate')}></i>
																		</th>
																		<th
																			// onClick={this.sortChanged.bind(this, 'appointmentTime', this.state.sortOrder)}
																			>
																			Clinic Name
                                <i /* className={this._sortClass('appointmentTime')} */></i>
																		</th>
																		<th
																		onClick={this.sortChanged.bind(this, 'patientDet.dateOfBirth', this.state.sortOrder)}
																		>
																			Age
                                <i className={this._sortClass('appointmentTime')}></i>
																		</th>
																		<th /* onClick={this.sortChanged.bind(this, 'patientDet.gender', this.state.sortOrder)} */
																		 >
																			Sex
																	{/* <i className={this._sortClass('patientDet.gender')}></i> */}
																		</th>
																		{!isAssistant ? <th /* onClick={this.sortChanged.bind(this, 'fee', this.state.sortOrder)} */
																		>
																			Symptoms
																	{/* <i className={this._sortClass('appointmentspecialistname')}></i> */}
																		</th>
																			: null
																		}
																		<th onClick={this.sortChanged.bind(this, 'fee', this.state.sortOrder)}>
																			Mode
																	<i className={this._sortClass('appointmentspecialistname')}></i>
																		</th>
																		<th /* onClick={this.sortChanged.bind(this, 'status', this.state.sortOrder)} */
																		>
																			Status
																	{/* <i className={this._sortClass('status')}></i> */}
																		</th>
																		{!isAssistant ? <th>Docs</th> : null}
																		{!isAssistant ? <th>History</th> : null}

																		{this.state.flag == 1 ? <th colSpan="3">Actions</th> : ''}
																		{/* {this.state.flag == 1 ? <th></th> : ''} */}
																	</tr>
																</thead>
																<tbody>{rows.length > 0 ? rows : <tr><td colSpan={13} className="text-center">There are no records found</td></tr>}</tbody>
															</table>
														</div>
													</div>
													{(appointmentsList && appointmentsList.length > 0) ?
														<div className="row">
															<div className="col-sm-5"><div className="showingEntries">Showing {(this.state.activePage * this.state.count) - (this.state.count - 1)} to {(this.state.activePage * this.state.count) > this.state.totalCount ? this.state.totalCount : (this.state.activePage * this.state.count)} of {this.state.totalCount} entries</div></div>
															<div className="col-sm-7 text-right" style={{ "cursor": "pointer" }}>
																<Pagination
																	prevPageText='Prev'
																	nextPageText='Next'
																	hideFirstLastPages
																	activePage={this.state.activePage}
																	itemsCountPerPage={10}
																	totalItemsCount={this.state.totalCount}
																	pageRangeDisplayed={10}
																	onChange={this.handlePageChange.bind(this)}
																/>

															</div>

														</div> : ''}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>
					}

					<div className="Copyrightafterlogin">
						<p>Medfix &copy; 2018. All rights reserved</p>

					</div>
				</div>

			</div>

		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		appointmentList: state.appointment.appointmentList ? state.appointment.appointmentList.appointmentData : '',
		noShowappointmentList: state.appointment.noShowappointmentList ? state.appointment.noShowappointmentList : '',
		totalCount: state.appointment.appointmentList ? state.appointment.appointmentList.totalCount : 0,
		// appointmentDocument: state.uploadDocument.uploadedImages ? state.uploadDocument.uploadedImages : ''
	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(appointmentActions, dispatch),
		logoutAction: bindActionCreators(dashboardActions, dispatch)

		// documentactions: bindActionCreators(documentActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(MyAppointment);
